import React from 'react';
import { MoreVertical, X } from 'lucide-react';
import { marginPositions } from '../../utils/portfolioData';
export function PositionsTable() {
  if (marginPositions.length === 0) {
    return <div className="flex flex-col items-center justify-center h-full py-16" data-id="element-1697">
        <div className="w-12 h-12 rounded-full bg-background-elevated flex items-center justify-center mb-3" data-id="element-1698">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-text-tertiary" data-id="element-1699">
            <path d="M3 3v18h18" data-id="element-1700" />
            <path d="M18 17V9" data-id="element-1701" />
            <path d="M13 17V5" data-id="element-1702" />
            <path d="M8 17v-3" data-id="element-1703" />
          </svg>
        </div>
        <p className="text-sm text-text-secondary" data-id="element-1704">No open positions.</p>
      </div>;
  }
  return <div className="h-full overflow-auto" data-id="element-1705">
      <table className="w-full" data-id="element-1706">
        <thead className="sticky top-0 bg-background-secondary z-10" data-id="element-1707">
          <tr className="border-b border-border-subtle" data-id="element-1708">
            <th className="text-left px-4 py-3 text-[10px] font-medium text-text-tertiary uppercase tracking-wider whitespace-nowrap" data-id="element-1709">
              Market
            </th>
            <th className="text-left px-4 py-3 text-[10px] font-medium text-text-tertiary uppercase tracking-wider whitespace-nowrap" data-id="element-1710">
              Side
            </th>
            <th className="text-right px-4 py-3 text-[10px] font-medium text-text-tertiary uppercase tracking-wider whitespace-nowrap" data-id="element-1711">
              Open Quantity
            </th>
            <th className="text-right px-4 py-3 text-[10px] font-medium text-text-tertiary uppercase tracking-wider whitespace-nowrap" data-id="element-1712">
              Opening Price
            </th>
            <th className="text-right px-4 py-3 text-[10px] font-medium text-text-tertiary uppercase tracking-wider whitespace-nowrap" data-id="element-1713">
              Current Price
            </th>
            <th className="text-right px-4 py-3 text-[10px] font-medium text-text-tertiary uppercase tracking-wider whitespace-nowrap" data-id="element-1714">
              Est. Liquidation
            </th>
            <th className="text-right px-4 py-3 text-[10px] font-medium text-text-tertiary uppercase tracking-wider whitespace-nowrap" data-id="element-1715">
              Initial Margin
            </th>
            <th className="text-right px-4 py-3 text-[10px] font-medium text-text-tertiary uppercase tracking-wider whitespace-nowrap" data-id="element-1716">
              UP&L
            </th>
            <th className="text-right px-4 py-3" data-id="element-1717"></th>
          </tr>
        </thead>
        <tbody data-id="element-1718">
          {marginPositions.map((position, idx) => <tr key={idx} className="border-b border-border-subtle hover:bg-background-elevated transition-colors group" data-id="element-1719">
              <td className="px-4 py-3" data-id="element-1720">
                <div className="flex items-center gap-2" data-id="element-1721">
                  <img src={position.logo} alt={position.symbol} className="w-5 h-5 object-contain" data-id="element-1722" />
                  <span className="font-medium text-text-primary text-sm" data-id="element-1723">
                    {position.market}
                  </span>
                  <span className="text-xs text-text-tertiary bg-background-elevated px-1.5 py-0.5 rounded" data-id="element-1724">
                    {position.leverage}x
                  </span>
                </div>
              </td>
              <td className="px-4 py-3" data-id="element-1725">
                <span className={`text-sm font-medium ${position.side === 'Long' ? 'text-success' : 'text-danger'}`} data-id="element-1726">
                  {position.side}
                </span>
              </td>
              <td className="px-4 py-3 text-right" data-id="element-1727">
                <div className="font-mono text-sm text-text-primary" data-id="element-1728">
                  {position.openQuantity.toFixed(8)}
                  <span className="text-text-secondary text-xs ml-1" data-id="element-1729">
                    {position.symbol}
                  </span>
                </div>
              </td>
              <td className="px-4 py-3 text-right" data-id="element-1730">
                <div className="font-mono text-sm text-text-primary" data-id="element-1731">
                  {position.openingPrice.toLocaleString('en-US', {
                minimumFractionDigits: 1,
                maximumFractionDigits: 1
              })}
                  <span className="text-text-secondary text-xs ml-1" data-id="element-1732">USD</span>
                </div>
              </td>
              <td className="px-4 py-3 text-right" data-id="element-1733">
                <div className="font-mono text-sm text-text-primary" data-id="element-1734">
                  {position.currentPrice.toLocaleString('en-US', {
                minimumFractionDigits: 1,
                maximumFractionDigits: 1
              })}
                  <span className="text-text-secondary text-xs ml-1" data-id="element-1735">USD</span>
                </div>
              </td>
              <td className="px-4 py-3 text-right" data-id="element-1736">
                <div className="font-mono text-sm text-text-primary" data-id="element-1737">
                  {position.estLiquidation.toLocaleString('en-US', {
                minimumFractionDigits: 1,
                maximumFractionDigits: 1
              })}
                  <span className="text-text-secondary text-xs ml-1" data-id="element-1738">USD</span>
                </div>
              </td>
              <td className="px-4 py-3 text-right" data-id="element-1739">
                <div className="font-mono text-sm text-text-primary" data-id="element-1740">
                  {position.initialMargin.toFixed(2)}
                  <span className="text-text-secondary text-xs ml-1" data-id="element-1741">USD</span>
                </div>
              </td>
              <td className="px-4 py-3 text-right" data-id="element-1742">
                <div className={`font-mono text-sm font-medium ${position.unrealizedPnl >= 0 ? 'text-success' : 'text-danger'}`} data-id="element-1743">
                  {position.unrealizedPnl >= 0 ? '+' : ''}
                  {position.unrealizedPnl.toFixed(2)}
                  <span className="text-xs ml-1" data-id="element-1744">
                    ({position.unrealizedPnlPercent >= 0 ? '+' : ''}
                    {position.unrealizedPnlPercent.toFixed(2)}%)
                  </span>
                </div>
              </td>
              <td className="px-4 py-3 text-right" data-id="element-1745">
                <div className="flex items-center justify-end gap-2 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-1746">
                  <button className="p-1 hover:bg-background-primary rounded transition-colors text-text-secondary hover:text-text-primary" data-id="element-1747">
                    <MoreVertical size={16} data-id="element-1748" />
                  </button>
                  <button className="p-1 hover:bg-background-primary rounded transition-colors text-text-secondary hover:text-danger" data-id="element-1749">
                    <X size={16} data-id="element-1750" />
                  </button>
                </div>
              </td>
            </tr>)}
        </tbody>
      </table>
    </div>;
}